/**
 * Link and cover-art helpers for published stories.
 *
 * These live outside PublishedStoryCard because they are not the card's: HomeView and
 * AuthorProfileView both build their own markup around the same URL shape, and the card, HomeView's
 * "Recently read" strip and the author grids all render `BookCover`, which asks for the same
 * rotating placeholder classes whenever a story has no generated cover. Keeping these in the card's
 * module also cost that file its Fast Refresh, since a module that exports both a component and
 * plain functions can't be hot-swapped.
 */

/** The canonical reader-facing path for a published story. */
export function publishedStoryUrl(story: PublishedStorySummary): string {
  return `/stories/${encodeURIComponent(story.id)}/${encodeURIComponent(story.slug)}`
}

/**
 * Cover class for the story at `index` in a list, cycling through the four defined in index.css.
 * Position-based rather than story-based on purpose: it keeps adjacent covers in a grid visually
 * distinct, which is what the rotation is for.
 */
export function storyCoverClass(index: number): string {
  return `home-story-cover home-story-cover-${(index % 4) + 1}`
}
